import * as React from 'react';
import * as TypeStyle from 'typestyle';
import { DynamicSvgIcon, encodeSvg, StepperLeftIcon, StepperRightIcon } from '../../icons/Icons';
import { ButtonProps, ButtonType } from '../Button/ButtonWidget';
import { ButtonWidget } from '../Button/ButtonWidgetShim';
import { Img } from '../DomWidgets';

export interface CarouselProps extends Pick<React.HTMLAttributes<HTMLElement>, 'id' | 'role' | 'style'> {
  nextButtonTitle?: string;
  onNextClick?: () => void;
  onPreviousClick?: () => void;
  prevButtonTitle?: string;
}

const CarouselStyleName = TypeStyle.style({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
});

const ButtonStyleName = TypeStyle.style({
  height: 30,
  width: 30,
});
function buttonIconFactory(icon: DynamicSvgIcon): ButtonProps['getContent'] {
  return state => <Img draggable={false} height={icon.height} src={encodeSvg(icon.icon(state))} width={icon.width} />;
}
const DynamicLeftArrowIcon = buttonIconFactory(StepperLeftIcon);
const DynamicRightArrowIcon = buttonIconFactory(StepperRightIcon);

// tslint:disable-next-line:max-line-length
export const CarouselWidget: React.FC<CarouselProps> = ({ children, id, nextButtonTitle, onNextClick, onPreviousClick, prevButtonTitle, role, style }) => {
  const [focusWithin, setFocusWithin] = React.useState(false);

  const prevMonthButton = <ButtonWidget
    buttonType={ButtonType.Icon}
    className={ButtonStyleName}
    getContent={DynamicLeftArrowIcon}
    handleClick={onPreviousClick}
    testId='stepper-left'
    title={prevButtonTitle}
  />;

  const nextMonthButton = <ButtonWidget
    buttonType={ButtonType.Icon}
    className={ButtonStyleName}
    getContent={DynamicRightArrowIcon}
    handleClick={onNextClick}
    testId='stepper-right'
    title={nextButtonTitle}
  />;

  return (
    <div className={CarouselStyleName} onBlur={() => setFocusWithin(false)} onFocus={() => setFocusWithin(true)} style={style}>
      {prevMonthButton}
      <span id={id} role={role} aria-live={focusWithin ? 'assertive' : 'off'} aria-atomic={true}>
        {children}
      </span>
      {nextMonthButton}
    </div>
  );
};
CarouselWidget.displayName = 'CarouselWidget';
